module.exports = __webpack_public_path__ + "img/open-menu.fd976a6b.svg";